import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TaskForm from "../../components/TaskForm";
import { TaskAPI } from "../../api/api";
import "./Tasks.css";

export default function EditTask() {
  const { id } = useParams(); // get task ID from route
  const navigate = useNavigate();
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadTask = async () => {
      try {
        const res = await TaskAPI.getById(id);
        setTask(res.data);
      } catch (err) {
        console.error("Failed to load task:", err);
      } finally {
        setLoading(false);
      }
    };
    loadTask();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!task) return <p>Task not found</p>;

  return (
    <div className="main">
      <div className="tasks-main">
        <h1>Edit Task</h1>
        <TaskForm
          editingTask={task}
          onSuccess={() => navigate("/tasks")}
        />
      </div>

    </div>
  );
}
